module.exports = __webpack_public_path__ + "img/mp.0f0bbe6d.png";